import React, { useRef, useEffect, useState } from 'react';
import { PLATFORM_TYPE } from '../active-stage/data';
import { Form, Select, Radio } from 'antd';
import GoodsScale from './components/goods-scale';
import CoreIndicators from '../active-stage/components/core-indicators';
import RankingList from './components/ranking-list';
import './index.less';
import ActivityDetailTable from '../activity-detail-table';
import CommodityDetailsTable from '../commodity-details-table';
import UserAnalysis from '../user-analysis';

const ResumptionPeriod = (props) => {
  const [position, setPosition] = useState('1');
  const [platformCd, setPlatform] = useState('全部');
  return (
    <div className="participant-data-period-card-bg ">
      <div className="period-platform-clear-fix">
        <div style={{ height: '60px', marginBottom: '-24px' }}>
          <Form.Item label="平台" style={{ width: '186px' }}>
            <Select
              allowClear={true}
              placeholder="请选择"
              onChange={(val) => {
                if (val) {
                  setPlatform(val);
                } else {
                  setPlatform('全部');
                }
                console.log('活动变化', val);
              }}
            >
              {PLATFORM_TYPE.map((item, index) => (
                <Select.Option key={index} value={item.val}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
            <div style={{ marginRight: '60px' }}>
              <div
                className={'participant-data-radio-tab' + (position === '1' ? ' select' : '')}
                onClick={() => {
                  setPosition('1');
                }}
              >
                活动概览
              </div>
              <div className={'participant-data-radio-line' + (position === '1' ? ' select' : '')} />
            </div>
            <div style={{ marginRight: '60px' }}>
              <div
                className={'participant-data-radio-tab' + (position === '2' ? ' select' : '')}
                onClick={() => {
                  setPosition('2');
                }}
              >
                会场明细
              </div>
              <div className={'participant-data-radio-line' + (position === '2' ? ' select' : '')} />
            </div>
            <div style={{ marginRight: '60px' }}>
              <div
                className={'participant-data-radio-tab' + (position === '3' ? ' select' : '')}
                onClick={() => {
                  setPosition('3');
                }}
              >
                商品明细
              </div>
              <div className={'participant-data-radio-line' + (position === '3' ? ' select' : '')} />
            </div>
            <div style={{ marginRight: '60px' }}>
              <div
                className={'participant-data-radio-tab' + (position === '4' ? ' select' : '')}
                onClick={() => {
                  setPosition('4');
                }}
              >
                用户分析
              </div>
              <div className={'participant-data-radio-line' + (position === '4' ? ' select' : '')} />
            </div>
          </div>
        </div>
      </div>
      {position === '1' && (
        <>
          <GoodsScale param={{ platformCd, planCode: props.planCode, period: '1' }} />
          <CoreIndicators title="核心指标复盘" platformCd={platformCd} planCode={props.planCode} period="1" />
          <RankingList param={{ platformCd, planCode: props.planCode }} />
        </>
      )}
      {position === '2' && (
        <ActivityDetailTable statisticsDimension="1" planCode={props.planCode} platform={platformCd} />
      )}
      {position === '3' && (
        <CommodityDetailsTable statisticsDimension="1" planCode={props.planCode} platform={platformCd} />
      )}
      {position === '4' && <UserAnalysis planCode={props.planCode} platformCd={platformCd} />}

      {/* <ActivityDetailTable statisticsDimension="1" planCode={props.planCode} platform={platformCd} />
      <CommodityDetailsTable statisticsDimension="1" planCode={props.planCode} platform={platformCd} /> */}
    </div>
  );
};
export default ResumptionPeriod;
